import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { queryClient } from './queryClient';
import { useAuthStore } from '../stores/auth';

/**
 * Access-токен живёт в памяти вкладки и теряется при перезагрузке.
 * Восстанавливаем сессию по refresh-cookie до первого рендера защищённых роутов.
 */
function SessionBootstrap({ children }: { children: ReactNode }) {
  const bootstrap = useAuthStore((state) => state.bootstrap);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return <>{children}</>;
}

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionBootstrap>{children}</SessionBootstrap>
    </QueryClientProvider>
  );
}
